import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import defaultProfile from "./default";
import { commonMenuItems } from "./common";
import { i18n } from "@/i18n";
const { t } = i18n.global;

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const join = () => {
  window.open(t("ngp/settings/section/aloft_wiki/link"), "_blank", "noopener,noreferrer");
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "mapCreation" } },
  { component: "ConfSection", props: { name: "basic" } },
  { component: "TableSection", props: { name: "adminList" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/aloft_wiki",
    joinFn: join,
  },
});
